<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >

    <base-material-card
      icon="mdi-clipboard-text"
      :title="'Список ресторана ' + restaurantName "
      class="px-5 py-3"
    >
      <v-simple-table>
        <thead>
        <tr>
          <th class="primary--text">
            ID
          </th>
          <th class="primary--text">
            Название
          </th>
          <th class="primary--text">
            Среднее время
          </th>
          <th class="primary--text">
            Можно бронировать за
          </th>
          <th class="primary--text">
            Активность
          </th>
          <th class="text-right primary--text">
            Порядок сортировки
          </th>
          <th class="text-right primary--text">
            Дата создания
          </th>
          <th class="text-right primary--text">
            Действия
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="zone in zones" :key="zone.id">
          <td>{{zone.id}}</td>
          <td>{{zone.title}}</td>
          <td>{{zone.avgSpentTime}}</td>
          <td>{{zone.availableReserveBeforeTime}}</td>
          <td>
            <v-chip
              class="ma-2"
              :color="zone.isActive ? 'primary' : 'red'"
            >
              {{zone.isActive ? 'Бронирование доступно' : 'Бронирование недоступно'}}
            </v-chip>
          </td>
          <td class="text-right">
            {{zone.sortOrder}}
          </td>
          <td class="text-right">
            {{zone.createdAt}}
          </td>
          <td class="text-right">
            <v-btn @click="$router.push({'name' : 'RestaurantZoneEdit', params : {id : zone.id, restaurantId : restaurantId}})" color="primary" fab small dark title="Редактирование">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn color="blue" title="Зоны бронирования" fab small dark>
              <v-icon>mdi-table-edit</v-icon>
            </v-btn>
            <v-btn color="red" fab small dark title="Удалить" @click="deleteZone(zone.id)">
              <v-icon>mdi-delete-alert</v-icon>
            </v-btn>
          </td>
        </tr>

        </tbody>
      </v-simple-table>
    </base-material-card>
    <v-card-text style="height: 100px; position: relative">
      <v-fab-transition>
        <v-btn
          @click="$router.push({'name' : 'RestaurantZoneCreate', params : {restaurantId : restaurantId}})"
          title="Добавить ресторан"
          color="blue"
          dark
          absolute
          top
          right
          fab
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-card-text>
    <div class="py-3"/>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    props:{
      restaurantId : {
        type : [Number, String],
      }
    },
    mounted() {
      this.$store.dispatch('restaurantZones/loadZones', {
        restaurantId : this.restaurantId
      });
      this.$store.dispatch('restaurants/getRestaurant', {
        id : this.restaurantId
      }).then((data) => {
        this.restaurant = data.data
      })
    },
    data() {
      return {
        restaurant : {}
      }
    },
    methods:{
      agreeDelete(data){
        this.$store.dispatch('restaurantZones/removeZones', {
          restaurantId : this.restaurantId,
          id : data.id
        })
      },
      deleteZone(id){
        bus.$emit('modalAgree', {
          text : 'Если вы удалите зону, то удалится вся информация о ней, в том числи и все резервы. Вы согласны ?',
          callback : this.agreeDelete,
          params : {
            id : id
          }
        })
      }
    },
    computed: {
      restaurantName(){
        return this.restaurant.title
      },
      zones() {
        return this.$store.getters['restaurantZones/getZones']
      }
    }
  }
</script>
